import { useContext, useState } from 'react';
// import { useLocation } from "react-router-dom";
// import customBreadcrump from "@helper/customBreadcrump";
import { UserContext } from '@/context/createContext';
import { useDarkMode } from '@/context/DarkModeContext';
import ModalAddContent from './ModalAddContent';
import AddCustomer from '../modules/customers/AddCustomer';
import ModalInviteAgent from '../modules/agents/ModalInviteAgent';
import ModalSearchContent from './ModalSearchContent';
import DefaultImageUser from '../modules/Default-Image/DefaultImageUser';
import { Dropdown, DropdownItem, DropdownMenu, DropdownTrigger } from '@heroui/react';
import { useNavigate } from 'react-router-dom';
import ConfirmationModal from '@/core/ConfirmationModal';
import { deleteAllCookies } from '@/helper/functions';
import { getImageUrl } from '@/helper/getImageUrl';
import api from '@/services/axios';
import { useMutation } from '@tanstack/react-query';
import ToastSuccess from '../modules/toast/ToastSuccess';

export default function Header() {
  const {
    clearUser,
    user: { ProfilePicture, Name, UserType },
  } = useContext(UserContext);

  const { isDark, toggleDarkMode } = useDarkMode();
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [openSheet, setOpenSheet] = useState(null);
  const [openSearch, setOpenSearch] = useState(false);
  const [openProfile, setOpenProfile] = useState(false);
  const navigate = useNavigate();

  const { isPending, mutate: logout } = useMutation({
    mutationKey: ['logout'],
    mutationFn: async () => await api.delete('/auth/logout'),
    enabled: false,
    onSuccess: (res) => {
      ToastSuccess({ content: 'شما با موفقیت از حساب کاربری خارج شدید' });
    },
    onError: () => {
      ToastError({ content: 'خطایی از سمت سرور رخ داده !' });
    },
  });

  // const { pathname } = useLocation();
  // const [today, setToday] = useState("");
  // const [breadcrump, setBreadcrump] = useState();

  // useEffect(() => {
  //   setToday(new Date().toLocaleString("fa-IR", { dateStyle: "medium" }));
  //   setBreadcrump(customBreadcrump(pathname));
  // }, [pathname]);

  const [openModal, setOpenModal] = useState(false);

  const menuProfile = [
    {
      id: 1,
      name: 'پروفایل کاربری',
      url: `/settings#MyProfile`,
      icon: (
        <svg className="size-5 lg:size-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle stroke="currentColor" cx="12" cy="7" r="4" strokeWidth="1.5" strokeLinecap="round" />
          <path
            stroke="currentColor"
            d="M5.33788 18.3206C5.99897 15.5269 8.77173 14 11.6426 14H12.3574C15.2283 14 18.001 15.5269 18.6621 18.3206C18.79 18.8611 18.8917 19.4268 18.9489 20.0016C19.0036 20.5512 18.5523 21 18 21H6C5.44772 21 4.99642 20.5512 5.0511 20.0016C5.1083 19.4268 5.20997 18.8611 5.33788 18.3206Z"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
      ),
    },
    // { id: 4, name: 'خروج', url: `/` },
    // { name: "تماس با ما", url: `/contact-us` },
    // { name: "درباره ما", url: `/about-us` },
  ];

  const logoutHandler = async () => {
    await deleteAllCookies();
    await logout();
    await clearUser();
    navigate('/login', { replace: true });
  };

  return (
    <>
      <div className="bg-transparent md:mt-4 mt-0 mb-0 flex flex-row gap-4 border-b-[1px] md:border-[1px] py-4 px-6 md:py-2 md:px-4 rounded-none md:rounded-2xl border-blackFont-200 dark:border-blackFont-700 items-center justify-between font-normal text-blackFont-800 dark:text-blackFont-50 w-full max-Width">
        {/* <div className="flex flex-row items-center">
        <p className="text-base max-sm:text-xs">{today}</p>
        <span className="w-2 h-2 max-sm:w-1 max-sm:h-1 rounded-full bg-blackFont-800 mx-5 max-sm:mx-1.5"></span>
        <p className="text-sm max-sm:text-[10px]">{breadcrump?.title}</p>
        {breadcrump?.sub && (
          <>
            <span className="px-2 max-sm:px-1 text-blackFont-800">
              <img src="/svg/arrow-left.svg" alt="arrow-left" className="w-fit h-fit" />
            </span>
            <p className="text-sm max-sm:text-[10px]">{breadcrump.sub}</p>
          </>
        )}
        {breadcrump?.sub2 && (
          <>
            <span className="px-2 max-sm:hidden">
              <img src="/svg/arrow-left.svg" alt="arrow-left" className="w-fit h-fit" />
            </span>
            <p className="text-sm max-sm:text-xs max-sm:hidden">{breadcrump.sub2}</p>
          </>
        )}
      </div>
      <div className="flex flex-row items-center gap-6 text-blackFont-800 max-sm:gap-4">
        <a
          href="tel:09120303565"
          data-tooltip-id="my-tooltip"
          data-tooltip-content={window.innerWidth > 640 ? "شماره تماس : 09120303565" : null}
          data-tooltip-place="right"
          className="flex flex-row items-center gap-1.5 cursor-pointer"
        >
          <span className="max-sm:hidden">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M21.9676 18.3298C21.9676 18.6898 21.8876 19.0598 21.7176 19.4198C21.5476 19.7798 21.3276 20.1198 21.0376 20.4398C20.5476 20.9798 20.0076 21.3698 19.3976 21.6198C18.7976 21.8698 18.1476 21.9998 17.4476 21.9998C16.4276 21.9998 15.3376 21.7598 14.1876 21.2698C13.0376 20.7798 11.8876 20.1198 10.7476 19.2898C9.59756 18.4498 8.50756 17.5198 7.46756 16.4898C6.43756 15.4498 5.50756 14.3598 4.67756 13.2198C3.85756 12.0798 3.19756 10.9398 2.71756 9.80985C2.23756 8.66985 1.99756 7.57985 1.99756 6.53985C1.99756 5.85985 2.11756 5.20985 2.35756 4.60985C2.59756 3.99985 2.97756 3.43985 3.50756 2.93985C4.14756 2.30985 4.84756 1.99985 5.58756 1.99985C5.86756 1.99985 6.14756 2.05985 6.39756 2.17985C6.65756 2.29985 6.88756 2.47985 7.06756 2.73985L9.38756 6.00985C9.56756 6.25985 9.69756 6.48985 9.78756 6.70985C9.87756 6.91985 9.92756 7.12985 9.92756 7.31985C9.92756 7.55985 9.85756 7.79985 9.71756 8.02985C9.58756 8.25985 9.39756 8.49985 9.15756 8.73985L8.39756 9.52985C8.28756 9.63985 8.23756 9.76985 8.23756 9.92985C8.23756 10.0098 8.24756 10.0798 8.26756 10.1598C8.29756 10.2398 8.32756 10.2998 8.34756 10.3598C8.52756 10.6898 8.83756 11.1198 9.27756 11.6398C9.72756 12.1598 10.2076 12.6898 10.7276 13.2198C11.2676 13.7498 11.7876 14.2398 12.3176 14.6898C12.8376 15.1298 13.2676 15.4298 13.6076 15.6098C13.6576 15.6298 13.7176 15.6598 13.7876 15.6898C13.8676 15.7198 13.9476 15.7298 14.0376 15.7298C14.2076 15.7298 14.3376 15.6698 14.4476 15.5598L15.2076 14.8098C15.4576 14.5598 15.6976 14.3698 15.9276 14.2498C16.1576 14.1098 16.3876 14.0398 16.6376 14.0398C16.8276 14.0398 17.0276 14.0798 17.2476 14.1698C17.4676 14.2598 17.6976 14.3898 17.9476 14.5598L21.2576 16.9098C21.5176 17.0898 21.6976 17.2998 21.8076 17.5498C21.9076 17.7998 21.9676 18.0498 21.9676 18.3298Z"
                stroke="#242424"
                stroke-miterlimit="10"
              />
              <path
                d="M18.4961 8.99994C18.4961 8.39994 18.0261 7.47994 17.3261 6.72994C16.6861 6.03994 15.8361 5.49994 14.9961 5.49994"
                stroke="#242424"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M21.9961 8.99985C21.9961 5.12985 18.8661 1.99985 14.9961 1.99985"
                stroke="#242424"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          <span className="sm:hidden">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M21.97 18.33C21.97 18.69 21.89 19.06 21.72 19.42C21.55 19.78 21.33 20.12 21.04 20.44C20.55 20.98 20.01 21.37 19.4 21.62C18.8 21.87 18.15 22 17.45 22C16.43 22 15.34 21.76 14.19 21.27C13.04 20.78 11.89 20.12 10.75 19.29C9.6 18.45 8.51 17.52 7.47 16.49C6.44 15.45 5.51 14.36 4.68 13.22C3.86 12.08 3.2 10.94 2.72 9.81C2.24 8.67 2 7.58 2 6.54C2 5.86 2.12 5.21 2.36 4.61C2.6 4 2.98 3.44 3.51 2.94C4.15 2.31 4.85 2 5.59 2C5.87 2 6.15 2.06 6.4 2.18C6.66 2.3 6.89 2.48 7.07 2.74L9.39 6.01C9.57 6.26 9.7 6.49 9.79 6.71C9.88 6.92 9.93 7.13 9.93 7.32C9.93 7.56 9.86 7.8 9.72 8.03C9.59 8.26 9.4 8.5 9.16 8.74L8.4 9.53C8.29 9.64 8.24 9.77 8.24 9.93C8.24 10.01 8.25 10.08 8.27 10.16C8.3 10.24 8.33 10.3 8.35 10.36C8.53 10.69 8.84 11.12 9.28 11.64C9.73 12.16 10.21 12.69 10.73 13.22C11.27 13.75 11.79 14.24 12.32 14.69C12.84 15.13 13.27 15.43 13.61 15.61C13.66 15.63 13.72 15.66 13.79 15.69C13.87 15.72 13.95 15.73 14.04 15.73C14.21 15.73 14.34 15.67 14.45 15.56L15.21 14.81C15.46 14.56 15.7 14.37 15.93 14.25C16.16 14.11 16.39 14.04 16.64 14.04C16.83 14.04 17.03 14.08 17.25 14.17C17.47 14.26 17.7 14.39 17.95 14.56L21.26 16.91C21.52 17.09 21.7 17.3 21.81 17.55C21.91 17.8 21.97 18.05 21.97 18.33Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeMiterlimit="10"
              />
              <path
                d="M18.5 9C18.5 8.4 18.03 7.48 17.33 6.73C16.69 6.04 15.84 5.5 15 5.5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M22 9C22 5.13 18.87 2 15 2"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <p className="text-sm max-sm:hidden">پشتیبانی</p>
        </a>
      </div> */}
        <button
          onClick={() => setIsOpenModal(true)}
          className="text-sm font-medium text-primary dark:text-white px-4 py-2 rounded-lg hidden md:flex items-center gap-1 border-1 border-primary dark:border-blackFont-700 bg-white dark:bg-blackFont-800 hover:bg-primary hover:text-white dark:hover:bg-blackFont-700"
        >
          <svg className="w-[18px] h-[18px]">
            <use href="#plus"></use>
          </svg>
          افزودن
        </button>
        {/* <div className="flex items-center gap-2 max-md:w-full"> */}
        {/* <div
            onClick={() => setOpenSearch(true)}
            className="flex items-center gap-1.5 py-1.5 px-4 w-full md:w-72 text-text-normal border-1 border-light-grey rounded-lg cursor-pointer"
          >
            <span>
              <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12.4434 21C17.6901 21 21.9434 16.7467 21.9434 11.5C21.9434 6.25329 17.6901 2 12.4434 2C7.19665 2 2.94336 6.25329 2.94336 11.5C2.94336 16.7467 7.19665 21 12.4434 21Z"
                  stroke="#616161"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M22.9434 22L20.9434 20"
                  stroke="#616161"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
            <p className="text-sm text-text-normal">جستجو</p>
          </div> */}
        {/* </div> */}
        {/* <div className="flex items-center gap-4 px-3 cursor-pointer relative">
          <div className="size-12 rounded-full overflow-hidden">
            {ProfilePicture ? (
              <img src={`${import.meta.env.VITE_URL_IMG1}200${import.meta.env.VITE_URL_IMG2}/${ProfilePicture}`} alt="profile" className="w-full h-full" />
            ) : (
              <DefaultImageUser />
            )}
          </div>
          <div className="space-y-1">
            <p className="text-sm text-blackFont-800">{fullname}</p>
            <p className="text-xs text-blackFont-400">{UserType == 'Agent' ? 'مشاور املاک' : 'مدیر املاک'}</p>
          </div>
          <span>
            <svg className="size-3 text-blackFont-800" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M1 1.53345L3.94167 4.46678L6.88333 1.53345"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span> */}
        {/* profile */}
        {/* <div className="absolute w-full top-[70px] left-0 bg-white rounded-lg p-2 border-1 border-blackFont-200 flex flex-col gap-1 z-50">
            {menuProfile.map((i) => (
              <span className="py-2 px-4 hover:bg-blackFont-100/60 transition-all rounded-lg w-full" key={i.id}>
                {i.name}
              </span>
            ))}
          </div> */}
        {/* </div> */}
        <div className="flex items-center gap-6 justify-between md:w-auto w-screen">
          <a
            href="tel:09120303565"
            data-tooltip-id="my-tooltip"
            data-tooltip-content={window.innerWidth > 640 ? 'شماره تماس : 09120303565' : null}
            data-tooltip-place="bottom"
            className="flex flex-row items-center gap-1.5 cursor-pointer text-blackFont-800 dark:text-white"
            data-tooltip-class-name="z-20"
          >
            <span className="max-sm:hidden">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="text-blackFont-800 dark:text-white"
              >
                <path
                  d="M21.9676 18.3298C21.9676 18.6898 21.8876 19.0598 21.7176 19.4198C21.5476 19.7798 21.3276 20.1198 21.0376 20.4398C20.5476 20.9798 20.0076 21.3698 19.3976 21.6198C18.7976 21.8698 18.1476 21.9998 17.4476 21.9998C16.4276 21.9998 15.3376 21.7598 14.1876 21.2698C13.0376 20.7798 11.8876 20.1198 10.7476 19.2898C9.59756 18.4498 8.50756 17.5198 7.46756 16.4898C6.43756 15.4498 5.50756 14.3598 4.67756 13.2198C3.85756 12.0798 3.19756 10.9398 2.71756 9.80985C2.23756 8.66985 1.99756 7.57985 1.99756 6.53985C1.99756 5.85985 2.11756 5.20985 2.35756 4.60985C2.59756 3.99985 2.97756 3.43985 3.50756 2.93985C4.14756 2.30985 4.84756 1.99985 5.58756 1.99985C5.86756 1.99985 6.14756 2.05985 6.39756 2.17985C6.65756 2.29985 6.88756 2.47985 7.06756 2.73985L9.38756 6.00985C9.56756 6.25985 9.69756 6.48985 9.78756 6.70985C9.87756 6.91985 9.92756 7.12985 9.92756 7.31985C9.92756 7.55985 9.85756 7.79985 9.71756 8.02985C9.58756 8.25985 9.39756 8.49985 9.15756 8.73985L8.39756 9.52985C8.28756 9.63985 8.23756 9.76985 8.23756 9.92985C8.23756 10.0098 8.24756 10.0798 8.26756 10.1598C8.29756 10.2398 8.32756 10.2998 8.34756 10.3598C8.52756 10.6898 8.83756 11.1198 9.27756 11.6398C9.72756 12.1598 10.2076 12.6898 10.7276 13.2198C11.2676 13.7498 11.7876 14.2398 12.3176 14.6898C12.8376 15.1298 13.2676 15.4298 13.6076 15.6098C13.6576 15.6298 13.7176 15.6598 13.7876 15.6898C13.8676 15.7198 13.9476 15.7298 14.0376 15.7298C14.2076 15.7298 14.3376 15.6698 14.4476 15.5598L15.2076 14.8098C15.4576 14.5598 15.6976 14.3698 15.9276 14.2498C16.1576 14.1098 16.3876 14.0398 16.6376 14.0398C16.8276 14.0398 17.0276 14.0798 17.2476 14.1698C17.4676 14.2598 17.6976 14.3898 17.9476 14.5598L21.2576 16.9098C21.5176 17.0898 21.6976 17.2998 21.8076 17.5498C21.9076 17.7998 21.9676 18.0498 21.9676 18.3298Z"
                  stroke="currentColor"
                  strokeMiterlimit="10"
                />
                <path
                  d="M18.4961 8.99994C18.4961 8.39994 18.0261 7.47994 17.3261 6.72994C16.6861 6.03994 15.8361 5.49994 14.9961 5.49994"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M21.9961 8.99985C21.9961 5.12985 18.8661 1.99985 14.9961 1.99985"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
            <span className="sm:hidden">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M21.97 18.33C21.97 18.69 21.89 19.06 21.72 19.42C21.55 19.78 21.33 20.12 21.04 20.44C20.55 20.98 20.01 21.37 19.4 21.62C18.8 21.87 18.15 22 17.45 22C16.43 22 15.34 21.76 14.19 21.27C13.04 20.78 11.89 20.12 10.75 19.29C9.6 18.45 8.51 17.52 7.47 16.49C6.44 15.45 5.51 14.36 4.68 13.22C3.86 12.08 3.2 10.94 2.72 9.81C2.24 8.67 2 7.58 2 6.54C2 5.86 2.12 5.21 2.36 4.61C2.6 4 2.98 3.44 3.51 2.94C4.15 2.31 4.85 2 5.59 2C5.87 2 6.15 2.06 6.4 2.18C6.66 2.3 6.89 2.48 7.07 2.74L9.39 6.01C9.57 6.26 9.7 6.49 9.79 6.71C9.88 6.92 9.93 7.13 9.93 7.32C9.93 7.56 9.86 7.8 9.72 8.03C9.59 8.26 9.4 8.5 9.16 8.74L8.4 9.53C8.29 9.64 8.24 9.77 8.24 9.93C8.24 10.01 8.25 10.08 8.27 10.16C8.3 10.24 8.33 10.3 8.35 10.36C8.53 10.69 8.84 11.12 9.28 11.64C9.73 12.16 10.21 12.69 10.73 13.22C11.27 13.75 11.79 14.24 12.32 14.69C12.84 15.13 13.27 15.43 13.61 15.61C13.66 15.63 13.72 15.66 13.79 15.69C13.87 15.72 13.95 15.73 14.04 15.73C14.21 15.73 14.34 15.67 14.45 15.56L15.21 14.81C15.46 14.56 15.7 14.37 15.93 14.25C16.16 14.11 16.39 14.04 16.64 14.04C16.83 14.04 17.03 14.08 17.25 14.17C17.47 14.26 17.7 14.39 17.95 14.56L21.26 16.91C21.52 17.09 21.7 17.3 21.81 17.55C21.91 17.8 21.97 18.05 21.97 18.33Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeMiterlimit="10"
                />
                <path
                  d="M18.5 9C18.5 8.4 18.03 7.48 17.33 6.73C16.69 6.04 15.84 5.5 15 5.5"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M22 9C22 5.13 18.87 2 15 2"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
            <p className="text-sm max-sm:hidden text-blackFont-800 dark:text-white">پشتیبانی</p>
          </a>
          {/* دکمه تغییر تم فقط داخل منوی پروفایل قرار دارد */}
          <Dropdown
            onOpenChange={() => setOpenProfile(!openProfile)}
            placement="bottom-start"
            className="text-blackFont-800 dark:text-white"
          >
            <DropdownTrigger>
              <div className="flex items-center gap-3 md:gap-4 cursor-pointer relative">
                <div className="size-10 md:size-12 rounded-full overflow-hidden">
                  {ProfilePicture ? (
                    <img src={getImageUrl(ProfilePicture, 200)} alt="profile" className="w-full h-full" />
                  ) : (
                    <DefaultImageUser />
                  )}
                </div>
                <div className="space-y-1 hidden md:block">
                  <p className="text-sm text-blackFont-800 dark:text-white">{Name.fullName}</p>
                  <p className="text-xs text-blackFont-400 dark:text-white">
                    {UserType == 'Agent' ? 'مشاور املاک' : 'مدیر املاک'}
                  </p>
                </div>
                <span className={`${openProfile ? 'rotate-180' : 'rotate-0'} transition-all`}>
                  <svg
                    className="size-2.5 md:size-3 text-blackFont-800 dark:text-white"
                    viewBox="0 0 8 6"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 1.53345L3.94167 4.46678L6.88333 1.53345"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </div>
            </DropdownTrigger>
            <DropdownMenu aria-label="User Actions" variant="flat">
              <DropdownItem
                className="py-2 px-4 hover:!bg-blackFont-100/60 hover:!text-blackFont-900 transition-all rounded-lg w-full flex items-center gap-2"
                onPress={toggleDarkMode}
                startContent={
                  isDark ? (
                    // آیکون خورشید برای خروج از حالت تاریک
                    <svg
                      className="w-5 h-5 text-yellow-500"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
                      />
                    </svg>
                  ) : (
                    // آیکون ماه برای ورود به حالت تاریک
                    <svg
                      className="w-5 h-5 text-blackFont-700 dark:text-gray-300"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
                      />
                    </svg>
                  )
                }
              >
                {isDark ? 'حالت روشن' : 'حالت تاریک'}
              </DropdownItem>
              {menuProfile.map((i) => (
                <DropdownItem
                  onPress={() => navigate(i.url)}
                  className="py-2 px-4 hover:!bg-blackFont-100/60 hover:!text-blackFont-900 transition-all rounded-lg w-full"
                  key={i.id}
                  startContent={i.icon}
                >
                  {i.name}
                </DropdownItem>
              ))}
              <DropdownItem
                onPress={() => setOpenModal(true)}
                className="py-2 px-4 hover:!bg-error/10 hover:!text-error transition-all rounded-lg w-full"
                startContent={
                  <svg className="size-5 lg:size-6" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M17.6172 8.81979C17.2555 4.61979 15.0972 2.90479 10.3722 2.90479H10.2205C5.00552 2.90479 2.91719 4.99312 2.91719 10.2081V17.8148C2.91719 23.0298 5.00552 25.1181 10.2205 25.1181H10.3722C15.0622 25.1181 17.2205 23.4265 17.6055 19.2965"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M10.5007 14H23.7773"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M21.1757 10.0918L25.084 14.0001L21.1757 17.9085"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                }
              >
                خروج از حساب کاربری
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
      </div>
      {isOpenModal && (
        <ModalAddContent title="نوع محتوا خود را مشخص کنید" onOpenChange={setIsOpenModal} setOpenSheet={setOpenSheet} />
      )}
      {openSheet == 'customer' && <AddCustomer setShowModalAdd={setOpenSheet} />}
      {openSheet == 'agent' && <ModalInviteAgent isOpenRequest={openSheet} setIsOpenRequest={setOpenSheet} />}
      {openSearch && <ModalSearchContent onOpenChange={setOpenSearch} />}
      {openModal && (
        <ConfirmationModal
          setShowModal={setOpenModal}
          handler={() => logoutHandler()}
          title="خروج از حساب کاربری"
          desc="آیا از خروج از حساب کاربری خود اطمینان دارید؟"
          btnText="تأیید خروج"
        />
      )}
    </>
  );
}
